import Slider from "react-slick";
import { SlickArrowLeft, SlickArrowRight, SlickProps } from '../../../lib/Slick';
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { HomeMeetingItem } from './HomeMeetingItem';

export const HomeAuthorMeeting = () => {
    const { data: homeList, isLoading } = useQuery({
        queryKey: ['/home/meeting'],
        queryFn: () => Api.get('/api/meeting/home'),
        staleTime: 24 * 60 * 60 * 1000,
        gcTime: 24 * 60 * 60 * 1000
    });

    if (isLoading) return <div className="activity"></div>;

    const meetingList = homeList?.data?.map((meeting) => {
        return <HomeMeetingItem meeting={meeting} key={meeting.id} />;
    });


    return (
        <div className="authorMeeting activity">
            <Slider className="meeting_writer slider_wrap"
                {...SlickProps}
                slidesToShow={1} slidesToScroll={1} dots={false}
                autoplay={true}
                prevArrow={<SlickArrowLeft cn="prev_btn _yellow" />}
                nextArrow={<SlickArrowRight cn="next_btn _yellow" />}
                responsive={[{ breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1 } }]}
            >
                {homeList.data?.length <= 0 &&
                    <div className="no_data"><p>진행중인 책이랑 나랑이 없습니다.</p></div>
                }

                {meetingList}
            </Slider>
        </div>
    );
}

